import { BILLABLE_SOURCE_TYPES, type BillableSourceType } from '@/shared/api/billing';

/**
 * `validateSearch` of `/billing/billable-entries` (`AM-604`, decision 123 of the owner, 2026-10-25): the period
 * lives in the URL, so "Cargos calculados" of the file of a period opens Cargos already narrowed to it. `AM-843`
 * (C31-41, decision 124 A): and the origin, so "Consumidas" and "Excedente" of the same file open the charges
 * "Dentro del paquete" and "Excedente" of the period, the ones they add up. Anything else is dropped, never thrown
 * on.
 */
export interface EntriesSearch {
  billingPeriodId?: string;
  sourceType?: BillableSourceType;
}

export function entriesSearchSchema(search: Record<string, unknown>): EntriesSearch {
  const result: EntriesSearch = {};
  const period = search['billingPeriodId'];
  if (typeof period === 'string' && period.length > 0) {
    result.billingPeriodId = period;
  }
  const source = search['sourceType'];
  if (typeof source === 'string' && BILLABLE_SOURCE_TYPES.includes(source as BillableSourceType)) {
    result.sourceType = source as BillableSourceType;
  }
  return result;
}
